

import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss', '../../charts.style.scss']
})

export class DonutChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "chartdiv";
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits":"true",
                "type": "pie",
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "marginTop": 0,
                "marginRight": 10,
                "marginLeft": 10,
                "marginBottom": 0,
                "legend": {
                    "horizontalGap": 10,
                    "markerSize": 10,
                    "position": 'right',
                    "verticalGap": 0,
                    "labelText": "[[title]]",
                    "equalWidths":true,
                    "valueText" : ''
                },
                "theme": "light",
                "dataProvider": this.chartSpecification.data,
                "titleField": "title",
                "valueField": "value",
                "labelRadius": 5,
                "colorField": "color",
                "innerRadius": this.chartSpecification.pieRadius ? this.chartSpecification.pieRadius + '%' : "0%",
                "labelText": "",
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/pie/donute-chart/donut-chart.component.ts